import React from 'react';
import * as _ from 'lodash';

import InOutResultContext from '../../services/inOutResult/InOutResultContext';
import FieldTreesApi from '../../services/fieldTrees/FieldTreesApi';
import FieldTreesService from '../../services/fieldTrees/FieldTreesService';

import { SearchMenuHeader } from './SearchMenuHeader';
import { TextBox } from '../../components/textbox/TextBox';
import { SelectBox } from '../../components/select/SelectBox';
import DropdownSelector from '../dropdowns/DropdownSelector';
import { MultiCheckbox } from './WorkerSettingsSearch';

import {
  APPROVED_STATUS,
  SEARCH_CCUS_SENT_STATUS_CONDENSED,
  BODY_TEMPERATURE_THRESHOLD,
  ENTRANCE_WORKER_TYPES,
  ENTRANCE_EXIT_RECORD_STATUS,
} from '../../utilities/constants';

import Styles from '../../styles/componentStyle/inOutResult/inOutResult.scss';
import { isNullOrEmpty } from '../../utilities/stringUtil';

const MAIN_JV_COMPANY = 1;
/**
 * 入退場実績検索フォーム
 * @props {string}propertyName:ステート内のプロパティ名
 */
export class SearchForm extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <InOutResultContext.Consumer>
        {({
          state,
          searchFormHandle,
          selectedApprovedStatus,
          inputWorkerName,
          selectedSentStatus,
          selectedFieldTreeIds,
          selectedBodyTemperatureEnabled,
          selectedBodyTemperature,
          selectedPriorCcusError,
          selectCompanyIds,
          clearSearchProperty,
          doSearch,
          checkSingleSearchData,
          checkSingleData,
        }) => (
          <div className={`${Styles.search} master-slide-view__searchform`}>
            <div className='search-form'>
              <div className='form form--date-dropdown-list'>
                <div>{data.searchTitle.date}</div>
                <div className='form__group'>
                  <div className='form-element'>
                    <div className='sys-form-calender'>
                      <div className='dropdown-calender'>
                        <div className='dropdown-calender__input'>
                          <input
                            className='sys-dropdown-trigger sys-dropdown-trigger--force-down sys-name'
                            type='text'
                            name={`${[this.props.propertyName]}.fromDate`}
                            value={state[this.props.propertyName].fromDate}
                            onChange={() => null}
                            autoComplete='off'
                            readOnly
                          />
                          <div className='btn-spin'>
                            <button className='btn-spin__up sys-calender-day-up'>
                              <i className='i_arrow-top' />
                            </button>
                            <button className='btn-spin__down sys-calender-day-down'>
                              <i className='i_arrow-bottom' />
                            </button>
                          </div>
                        </div>
                        <div className='dropdown'>
                          <div className='dropdown-calender__calender' />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='form-element'>
                    <p className='hyphen'>〜</p>
                  </div>
                  <div className='form-element'>
                    <div className='sys-form-calender'>
                      <div className='dropdown-calender'>
                        <div className='dropdown-calender__input'>
                          <input
                            className='sys-dropdown-trigger sys-dropdown-trigger--force-down sys-name'
                            type='text'
                            name={`${[this.props.propertyName]}.toDate`}
                            value={state[this.props.propertyName].toDate}
                            onChange={() => null}
                            autoComplete='off'
                            readOnly
                          />
                          <div className='btn-spin'>
                            <button className='btn-spin__up sys-calender-day-up'>
                              <i className='i_arrow-top' />
                            </button>
                            <button className='btn-spin__down sys-calender-day-down'>
                              <i className='i_arrow-bottom' />
                            </button>
                          </div>
                        </div>
                        <div className='dropdown'>
                          <div className='dropdown-calender__calender' />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='form-element'>
                    <div className='prior-ccus-error'>
                      <div className='prior-ccus-error__checkbox'>
                        <input
                          id='prior-ccus-error-enabled'
                          type='checkbox'
                          name='prior-ccus-error-enabled'
                          checked={state.searchForm.priorCcusError}
                          onChange={e => {
                            selectedPriorCcusError(e.target.checked);
                          }}
                        />
                      </div>
                      <div className='prior-ccus-error__suffix'>
                        {data.errorPriority}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <SearchMenuHeader
                total={state[this.props.propertyName].total}
                isOpened={state[this.props.propertyName].isOpened}
                accordionButtonClass={this.props.propertyName}
                clearButtonName={this.props.propertyName}
                searchFormHandle={() => {
                  searchFormHandle(this.props.propertyName);
                }}
                clearSearchProperty={() => {
                  clearSearchProperty(this.props.propertyName);
                }}
              />
              <div
                id='search-form-accordion'
                className={`${this.props.propertyName} ${
                  state[this.props.propertyName].isOpened
                    ? 'accordion show'
                    : 'accordion'
                }`}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      {/* 入退場者種別 */}
                      {state.spotFlg && (
                        <div className='search-form-element'>
                          <div className='form__label'>
                            <span className='label'>
                              {data.searchTitle.workerType}
                            </span>
                          </div>
                          <div className='form__element'>
                            {_.map(ENTRANCE_WORKER_TYPES, item => {
                              return (
                                <label className='checkbox' key={item.id}>
                                  <input
                                    type='checkbox'
                                    name='checkbox'
                                    checked={_.some(
                                      state.searchForm.workerTypesList,
                                      item
                                    )}
                                    onChange={() =>
                                      checkSingleSearchData(
                                        'workerTypesList',
                                        item
                                      )
                                    }
                                  />
                                  <i
                                    className='i-square i-2x'
                                    aria-hidden='true'
                                  />
                                  <span className='radio-search-span'>
                                    {item.name}
                                  </span>
                                </label>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      <MultiCheckbox
                        label={data.searchTitle.entranceExitRecordStatus}
                        options={ENTRANCE_EXIT_RECORD_STATUS}
                        data={state.searchForm}
                        listName='entranceExitRecordStatus'
                        onChange={checkSingleData}
                      />
                      {/* 所属会社 */}
                      {isNullOrEmpty(state.fieldId) === false && (
                        <div className='search-form-element'>
                          <div className='multi-select-box__label'>
                            <span className='label'>
                              {data.searchTitle.companyName}
                            </span>
                          </div>
                          <div className='multi-select-box__element'>
                            <DropdownSelector
                              widthClass='dropdown__item--wide'
                              label={data.placeholder.companyName}
                              selectorName={this.props.propertyName}
                              selectedValues={state.searchForm.fieldTreeIds}
                              keyName='name'
                              valueName='field_tree_id'
                              multiple
                              api={param =>
                                FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                  state.fieldId,
                                  FieldTreesService.createSearchFieldTreeCompanyBranchList(
                                    param
                                  )
                                )
                              }
                              apiSearchKey='name'
                              apiBindDataKey='field_trees'
                              apiParams={state.fieldTreeBranchSearchForm}
                              onSelect={(name, values) => {
                                selectedFieldTreeIds(values);
                              }}
                              clearFlag={state.searchForm.clearFlag}
                            />
                          </div>
                        </div>
                      )}
                      {state.fieldId && (
                        <div className='search-form-element'>
                          <div className='multi-select-box__label'>
                            <span className='label'>
                              {data.searchTitle.primaryCompanyName}
                            </span>
                          </div>
                          <div className='multi-select-box__element'>
                            <DropdownSelector
                              widthClass='dropdown__item--wide'
                              itemWidthClass='multi-select__item'
                              label={data.placeholder.primaryCompanyName}
                              dropdownSelectStyle={{ width: '190px' }}
                              selectorName={this.props.propertyName}
                              selectedValues={
                                state.searchForm.primaryCompanyIds
                              }
                              keyName='company_name'
                              valueName='company_id'
                              multiple
                              api={param =>
                                FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                  state.fieldId,
                                  { ...param, nest_no: MAIN_JV_COMPANY }
                                )
                              }
                              apiSearchKey='name'
                              apiBindDataKey='field_trees'
                              apiParams={state.fieldTreeBranchSearchForm}
                              onSelect={(name, values) => {
                                selectCompanyIds(values);
                              }}
                              clearFlag={state.searchForm.clearFlag}
                            />
                          </div>
                        </div>
                      )}
                      <div className='search-form-element'>
                        <TextBox
                          label={data.searchTitle.workerName}
                          name={this.props.propertyName}
                          placeholder={data.placeholder.workerName}
                          value={state[this.props.propertyName].workerName}
                          onInput={event => {
                            inputWorkerName(event);
                          }}
                        />
                      </div>
                      {(state.bodyTemperatureExists === 1 ||
                        state.lastRequestWithTemperature) && (
                        <div className='search-form-element'>
                          <div className='select-box__label'>
                            <span className='label'>
                              {data.searchTitle.bodyTemperature}
                            </span>
                          </div>
                          <div className='select-box__element'>
                            <div className='body-temperature'>
                              <div className='body-temperature__checkbox'>
                                <input
                                  id='body-temperature-enabled'
                                  type='checkbox'
                                  name='body-temperature-enabled'
                                  checked={
                                    state.searchForm.bodyTemperatureEnabled
                                  }
                                  onChange={e => {
                                    selectedBodyTemperatureEnabled(
                                      e.target.checked
                                    );
                                  }}
                                />
                              </div>
                              <div className='body-temperature__select'>
                                <SelectBox
                                  name='body_temperature'
                                  value={state.searchForm.bodyTemperature}
                                  isPlaceholderHidden={true}
                                  items={BODY_TEMPERATURE_THRESHOLD}
                                  disabled={
                                    !state.searchForm.bodyTemperatureEnabled
                                  }
                                  onChange={e => {
                                    selectedBodyTemperature(e.target.value);
                                  }}
                                />
                              </div>
                              <div className='body-temperature__suffix'>
                                {data.bodyTemperatureSuffix}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className='search-form-element approved-status'>
                        <SelectBox
                          label={data.searchTitle.approvedStatus}
                          name={this.props.propertyName}
                          value={
                            state[this.props.propertyName]
                              .selectedApprovedStatus
                          }
                          placeholder={data.selectedOptions.all}
                          items={APPROVED_STATUS}
                          valueName='id'
                          keyName='id'
                          itemName='name'
                          onChange={event => {
                            selectedApprovedStatus(event);
                          }}
                        />
                      </div>
                      <div className='search-form-element'>
                        <SelectBox
                          label={data.searchTitle.sentStatus}
                          name={this.props.propertyName}
                          value={
                            state[this.props.propertyName].selectedSentStatus
                          }
                          placeholder={data.selectedOptions.all}
                          items={SEARCH_CCUS_SENT_STATUS_CONDENSED}
                          valueName='ID'
                          keyName='ID'
                          itemName='NAME'
                          onChange={event => {
                            selectedSentStatus(event);
                          }}
                        />
                      </div>
                      <div className='search-form-element'>
                        <button
                          className='btn-fixedsize--stay search-form__btn'
                          onClick={() => doSearch()}
                        >
                          {data.searchButtonTitle}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </InOutResultContext.Consumer>
    );
  }
}

// 定数
const data = {
  errorPriority: 'CCUS送信エラーを優先して表示する',
  clearButtonTitle: '検索条件クリア',
  searchButtonTitle: '検索',
  bodyTemperatureSuffix: '°C以上',
  searchTitle: {
    date: '期間',
    workerName: '氏名（カナ検索可）',
    approvedStatus: '承認状態',
    sentStatus: '送信状態',
    companyName: '所属会社',
    bodyTemperature: '体温',
    workerType: '入退場者種別',
    temperature: '体温',
    primaryCompanyName: '一次協力会社',
    entranceExitRecordStatus: '入退場記録状態',
  },
  selectedOptions: {
    all: 'すべて',
  },
  placeholder: {
    workerName: '作業員名を入力',
    companyName: '所属会社を選択',
    primaryCompanyName: '一次協力会社を選択',
  },
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/InOutResultSearch.jsx